'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSearchBoxText = exports.selectActiveLocation = exports.selectPreviousLocation = exports.selectSelectedLocation = exports.selectDefaultLocation = exports.selectSelectedKeywordId = exports.selectOpenPanel = exports.selectSearchBoxState = exports.clearLocationField = exports.setLocation = exports.setLocationFieldValue = exports.clearKeywordField = exports.setKeywordKey = exports.setKeyword = exports.setKeywordFieldValue = exports.setOpenPanel = exports.closeOpenPanel = exports.SET_KEYWORD = exports.SET_LOCATION = exports.SET_LOCATION_VALUE = exports.SET_KEYWORD_VALUE = exports.CLEAR_LOCATION = exports.CLEAR_KEYWORD = exports.CLOSE_OPEN_PANEL = exports.SET_OPEN_PANEL = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.reducer = reducer;

var _deep = require('helpers/deep');

var _Search = require('../Search.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_OPEN_PANEL = exports.SET_OPEN_PANEL = 'classpass/searchbox/SET_OPEN_PANEL';
var CLOSE_OPEN_PANEL = exports.CLOSE_OPEN_PANEL = 'classpass/searchbox/CLOSE_OPEN_PANEL';
var CLEAR_KEYWORD = exports.CLEAR_KEYWORD = 'classpass/searchbox/CLEAR_KEYWORD';
var CLEAR_LOCATION = exports.CLEAR_LOCATION = 'classpass/searchbox/CLEAR_LOCATION';
var SET_KEYWORD_VALUE = exports.SET_KEYWORD_VALUE = 'classpass/searchbox/SET_KEYWORD_VALUE';
var SET_LOCATION_VALUE = exports.SET_LOCATION_VALUE = 'classpass/searchbox/SET_LOCATION_VALUE';
var SET_LOCATION = exports.SET_LOCATION = 'classpass/searchbox/SET_LOCATION';
var SET_KEYWORD_KEY = 'classpass/searchbox/SET_KEYWORD_KEY';
var SET_KEYWORD = exports.SET_KEYWORD = 'classpass/searchbox/SET_KEYWORD';

var closeOpenPanel = exports.closeOpenPanel = function closeOpenPanel() {
  return { type: CLOSE_OPEN_PANEL, key: 'openPanel', value: null };
};
var setOpenPanel = exports.setOpenPanel = function setOpenPanel(value) {
  return { type: SET_OPEN_PANEL, key: 'openPanel', value: value };
};
var setKeywordFieldValue = exports.setKeywordFieldValue = function setKeywordFieldValue(value) {
  return { type: SET_KEYWORD_VALUE, key: 'keywordFieldValue', value: value };
};
var setKeyword = exports.setKeyword = function setKeyword(value) {
  return { type: SET_KEYWORD, value: value };
};
var setKeywordKey = exports.setKeywordKey = function setKeywordKey(value) {
  return { type: SET_KEYWORD_KEY, key: 'keywordKey', value: value };
};
var clearKeywordField = exports.clearKeywordField = function clearKeywordField() {
  return { type: CLEAR_KEYWORD };
};

var setLocationFieldValue = exports.setLocationFieldValue = function setLocationFieldValue(value) {
  return { type: SET_LOCATION_VALUE, value: value, key: 'locationFieldValue' };
};
var setLocation = exports.setLocation = function setLocation(location) {
  var defalt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return { type: SET_LOCATION, location: location, defalt: defalt };
};
var clearLocationField = exports.clearLocationField = function clearLocationField() {
  return { type: CLEAR_LOCATION };
};

var selectSearchBoxState = exports.selectSearchBoxState = function selectSearchBoxState(state) {
  return state.features.searchBox;
};
var selectOpenPanel = exports.selectOpenPanel = function selectOpenPanel(state) {
  return selectSearchBoxState(state).openPanel;
};
var selectSelectedKeywordId = exports.selectSelectedKeywordId = function selectSelectedKeywordId(state) {
  return selectSearchBoxState(state).keywordSelectedId;
};
var selectDefaultLocation = exports.selectDefaultLocation = function selectDefaultLocation(state) {
  return selectSearchBoxState(state).defaultLocation;
};
var selectSelectedLocation = exports.selectSelectedLocation = function selectSelectedLocation(state) {
  return selectSearchBoxState(state).selectedLocation;
};
var selectPreviousLocation = exports.selectPreviousLocation = function selectPreviousLocation(state) {
  return selectSearchBoxState(state).previousLocation;
};
var selectActiveLocation = exports.selectActiveLocation = function selectActiveLocation(state) {
  return selectSelectedLocation(state) || selectDefaultLocation(state);
};
var selectSearchBoxText = exports.selectSearchBoxText = function selectSearchBoxText(state) {
  var _selectSearchBoxState = selectSearchBoxState(state),
      keywordDisplayValue = _selectSearchBoxState.keywordDisplayValue,
      selectedLocation = _selectSearchBoxState.selectedLocation,
      defaultLocation = _selectSearchBoxState.defaultLocation;

  var locationDisplayValue = (0, _deep.deepExtract)('locationName', selectedLocation || defaultLocation, '');

  return keywordDisplayValue + ' / ' + locationDisplayValue;
};

var initialState = {
  keywordKey: '',
  keywordFieldValue: '',
  keywordDisplayValue: '',
  keywordSelectedId: '',
  locationFieldValue: '',
  openPanel: null,
  selectedLocation: null,
  defaultLocation: null,
  previousLocation: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLOSE_OPEN_PANEL:
    case SET_OPEN_PANEL:
    case SET_KEYWORD_KEY:
    case SET_KEYWORD_VALUE:
    case SET_LOCATION_VALUE:
      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.key, action.value));
    case SET_KEYWORD:
      return (0, _extends5.default)({}, state, {
        keywordDisplayValue: action.value.name,
        keywordSelectedId: action.value.id
      });
    case SET_LOCATION:
      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({
        previousLocation: (0, _extends5.default)({}, state.selectedLocation || {})
      }, action.defalt ? 'defaultLocation' : 'selectedLocation', (0, _extends5.default)({}, action.location, {
        isKeywordSearch: action.location.locationName !== _Search.MAPPED_AREA
      })));
    case CLEAR_KEYWORD:
      return (0, _extends5.default)({}, state, {
        keywordDisplayValue: '',
        keywordFieldValue: '',
        keywordSelectedId: ''
      });
    case CLEAR_LOCATION:
      return (0, _extends5.default)({}, state, {
        previousLocation: (0, _extends5.default)({}, state.selectedLocation || {}),
        locationFieldValue: '',
        selectedLocation: null
      });
    default:
      return state;
  }
}